
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.188 2.906c.203 0 .406.102.558.254a.816.816 0 01.254.56v.812a.841.841 0 01-.254.61c-.152.152-.355.203-.558.203H14.624v1.218a.841.841 0 01-.254.61c-.152.152-.355.203-.559.203h-1.624c-.254 0-.458-.05-.61-.203-.152-.152-.203-.356-.203-.61V5.345H.812c-.253 0-.457-.051-.609-.203C.051 4.988 0 4.785 0 4.53v-.81c0-.203.05-.406.203-.559a.84.84 0 01.61-.254h10.562v-1.22c0-.203.05-.406.203-.558a.841.841 0 01.61-.254h1.624a.82.82 0 01.56.254.816.816 0 01.253.558v1.22h10.563zm0 16.25c.203 0 .406.102.558.254a.815.815 0 01.254.559v.812a.84.84 0 01-.254.61c-.152.152-.355.203-.558.203H8.125v1.218a.841.841 0 01-.254.61c-.152.152-.355.203-.559.203H5.688c-.253 0-.457-.05-.609-.203-.152-.152-.203-.356-.203-.61v-1.218H.812c-.253 0-.457-.051-.609-.203-.152-.153-.203-.356-.203-.61v-.812c0-.203.05-.407.203-.559a.84.84 0 01.61-.254h4.062v-1.218c0-.204.05-.407.203-.56a.841.841 0 01.61-.253h1.625c.203 0 .406.102.558.254a.815.815 0 01.254.558v1.22h17.063zm0-8.125c.203 0 .406.102.558.254a.815.815 0 01.254.559v.812a.84.84 0 01-.254.61c-.152.152-.355.203-.558.203h-4.063v1.219a.841.841 0 01-.254.609c-.152.152-.355.203-.558.203h-1.625c-.254 0-.457-.05-.61-.203-.152-.152-.203-.356-.203-.61V13.47H.812c-.253 0-.457-.051-.609-.203-.152-.153-.203-.356-.203-.61v-.812c0-.203.05-.406.203-.559a.84.84 0 01.61-.254h17.062v-1.22c0-.203.05-.406.203-.558a.841.841 0 01.61-.254h1.625c.203 0 .406.102.558.254a.816.816 0 01.254.559v1.218h4.063z"}})])
          )
        }
      }
    